module.exports = __webpack_public_path__ + "img/clip-completed-form.316d525b.png";